import "../style.scss";
import { GeneralLocationPrimerModal } from "@src/app/openShifts/urgentShifts/generalLocationPrimerModal/generalLocationPrimerModal";
import { requestFullLocationAccess } from "@src/app/openShifts/urgentShifts/utils";

import { PushNotificationAlert } from "../../AppAlerts";
import {
  MissingDocumentsAlert,
  OverworkBookingAlert,
  PendingDocumentsAlert,
  ShiftBookingWarningDialog,
  WaitingStripeResponseAlert,
} from "../Alerts";
import { ShiftPayChangedModal } from "../Alerts";
import { ShiftItemAlertsProps, ShiftItemCategory } from "../model";

export const ShiftItemAlerts = ({
  shift,
  category,
  isInstantBookingShift,
  alertOpen,
  onCancel,
  onConfirm,
  pushNotificationOpen,
  closePushNotification,
  isUrgentShift,
  missingDocs,
  onClosePrimerPage,
  changedShiftPayText,
}: ShiftItemAlertsProps) => {
  const onGoToLocationSettingClicked = () => {
    onClosePrimerPage();
    requestFullLocationAccess();
  };

  return (
    <>
      <ShiftPayChangedModal
        isOpen={category === ShiftItemCategory.SHIFT_PAY_CHANGED && alertOpen}
        onDidDismiss={onCancel}
        onConfirm={onConfirm}
        changedShiftPayText={changedShiftPayText}
      />

      <ShiftBookingWarningDialog
        isOpen={[ShiftItemCategory.BOOKING_WARNING].includes(category) && alertOpen}
        onClose={onCancel}
        onConfirm={onConfirm}
        shift={shift}
        isInstantBookingShift={isInstantBookingShift}
        isUrgentShift={isUrgentShift}
        isLoading={false}
      />

      <WaitingStripeResponseAlert
        isOpen={category === ShiftItemCategory.NOT_READY_TO_BOOK_SHIFT && alertOpen}
        onDidDismiss={onCancel}
      />

      <OverworkBookingAlert
        isOpen={category === ShiftItemCategory.OVERWORK_BOOKING && alertOpen}
        onDidDismiss={onCancel}
      />

      {[
        ShiftItemCategory.MISSING_CBH_DOCUMENTS,
        ShiftItemCategory.MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END,
        ShiftItemCategory.STRIPE_NOT_CONNECTED_AND_MISSING_HCP_DOCUMENTS,
        ShiftItemCategory.STRIPE_NOT_CONNECTED_AND_MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END,
      ].indexOf(category) !== -1 && (
        <MissingDocumentsAlert
          isOpen={alertOpen}
          category={category}
          onConfirm={onConfirm}
          onDidDismiss={onCancel}
          missingDocuments={missingDocs}
          expiringInFuture={category === ShiftItemCategory.MISSING_CBH_DOCUMENTS_BEFORE_A_SHIFT_END}
        />
      )}
      <PendingDocumentsAlert
        isOpen={[ShiftItemCategory.WAITING_FOR_APPROVE].indexOf(category) !== -1 && alertOpen}
        shift={shift}
        category={category}
        onConfirm={onConfirm}
        onDidDismiss={onCancel}
      />

      {pushNotificationOpen && (
        <PushNotificationAlert isOpen={pushNotificationOpen} onClosed={closePushNotification} />
      )}
      <GeneralLocationPrimerModal
        onAllowLocationClick={onGoToLocationSettingClicked}
        onDeny={onClosePrimerPage}
        onDidDismiss={onClosePrimerPage}
        isOpen={alertOpen && category === ShiftItemCategory.NO_LOCATION_PERMISSION}
      />
    </>
  );
};
